function init() {
	(function(a,b,c,d){var e=a.getElementsByTagName(b)[0],f=a.createElement(b);f.async=!0,f.src="https://image.sendsay.ru/app/js/sdk/sdk.min.js",f.id="sendsay-sdk-script",f.dataset.accountId=c,f.dataset.siteId=d,e.parentNode.insertBefore(f,e)})(document,"script","cloudpaymentss","pl88641");
}

export default {
	init,
};
